export function objectToQueryString(obj, prependQuestion = true) {
    return obj
        ? `${prependQuestion ? "?" : ""}${Object.keys(obj)
            .map(function (key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]);
        })
            .join("&")}`
        : "";
}
